import React from 'react';
import Button from './Button';
import './commonStyle.css';

/**
 * AlertModal - Styled replacement for native alert() calls
 *
 * Props:
 * - show: boolean - whether to show the modal
 * - title: string - modal title (optional, defaults to "Notice")
 * - message: string - the message to display
 * - eviewMode: boolean - use green theme for eView mode
 * - onClose: function - callback when OK is clicked
 * - type: 'info' | 'warning' | 'error' - affects icon/styling (optional)
 */
const AlertModal = ({ show, title, message, eviewMode, onClose, type = 'info' }) => {
  if (!show) return null;

  const titleClass = type === 'error'
    ? 'common-alert__title common-alert__title--error'
    : type === 'warning'
    ? 'common-alert__title common-alert__title--warning'
    : 'common-alert__title';

  const defaultTitle = type === 'error' ? 'Error' : type === 'warning' ? 'Warning' : 'Notice';

  return (
    <div className="common-modal-overlay">
      <div className={`common-alert ${eviewMode ? 'eview-mode' : ''}`}>
        <p className={titleClass}>
          {title || defaultTitle}
        </p>
        <p className="common-alert__message">{message}</p>
        <div className="common-alert__buttons">
          <Button onClick={onClose} buttonText="OK" />
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
